module.exports = __webpack_public_path__ + "static/puas_2-3-3e15cc0a557340bd5d6d96e5563b772d.png";